import styled from 'styled-components';
import { variables } from 'components/theme';

export const Wrapper = styled.footer`
  ${variables.fonts.overpassMonoRegular}
  background: ${variables.colors.grey4};
  color: ${variables.colors.gray7};
  padding: 42px 0;
  transition: .3s all ease-in-out;

  .bg-dark::before {
    background: ${variables.colors.grey4};
    box-shadow: 0 0 0 1px ${variables.colors.white};
  }

  @media (min-width: 1024px){
    position: fixed;
    z-index: 6;
    bottom: 0px;
    width: 100%;
  }
`;

export const Col12 = styled.div`
  flex: 0 0 75%;
  max-width: 75%;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

export const Col3 = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media (max-width: 768px) {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 0;
  }
`;

export const FooterLogo = styled.img`
  width: 107px;
`;

export const Links = styled.div`
  width: 75%;
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;

  span {
    margin-bottom: 1.5rem;
    color: ${variables.colors.white};
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 10%;
    justify-content: space-between;
  }
`;

export const Info = styled.div`
  width: 25%;

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 1.5rem;
    text-align: center;
  }
`;

export const NavItem = styled.li`
  padding: 7px 0;
  color: ${variables.colors.grey17};

  button {
    background: transparent;
    padding: 0px;
    margin: 0px;
    border: none;
    color: inherit;
    font-size: 14px;

    &:hover {
      color: #fff;
    }
  }
`;

export const NavLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-size: 14px;

  &:hover {
    color: #fff;
  }
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const Slogan = styled.div`
  ${variables.fonts.openSansSemiBold}
  font-size: 15px;
  line-height: 1.4;
  padding: 1rem 0;
  color: ${variables.colors.white};
`;

export const Newsletter = styled.div`
  input {
    background: ${variables.colors.grey4};
    display: block;
    width: 100%;
    margin: 14px 0;
    padding: 7px 14px;
    font-weight: 400;
    color: ${variables.colors.grey17};
    background-clip: padding-box;
    border: 1px solid ${variables.colors.grey17};
    border-radius: 1px;
    font-size: 14px;
  }

  input:focus {
    background: ${variables.colors.grey4};
    color: ${variables.colors.grey17};
    box-shadow: none;
  }

  input::placeholder {
    color: ${variables.colors.grey17};
    font-size: 14px;
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: white;
  }
`;

export const NewsletterLabel = styled.label`
  color: ${variables.colors.gray7};
`;

export const Copyright = styled.p`
  font-size: 13px;
  color: ${variables.colors.white};
  margin-top: 2rem;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const ToggleWrapper = styled.div`
  z-index: 7;
  position: fixed;
  right: 1%;
  bottom: 20px;

  button {
    outline: none;
    margin: 0px;
    display: flex;
    align-items: center;
    font-size: 13px;
    padding: 7px 14px;
    border-radius: 8px;
    border: 1px none white;
    line-height: 18px;
    ${variables.fonts.openSansSemiBold};
    box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 16px;
    background-color: ${variables.colors.white};
  }

  svg {
    margin-right: 12px;
    height: 15px;
    width: 15px;
  }
`;

export default Wrapper;
